import React from 'react'

import { useTranslation } from 'react-i18next'

import iconPdf from '../../../assets/icons-pdf.png'
import { SectionText } from '../../../components/SectionText'

interface DownloadProps {
    className?: string
}

export const Download: React.FC<DownloadProps> = ({ className }) => {
    const { t } = useTranslation()
    return (
        <div
            id="download"
            className={`${className} flex justify-between min-h-[400px] h-auto w-full text-white bg-primary-green
            sm:flex-col
        `}>
            <div
                className="w-1/2 h-full flex items-center justify-center
                sm:w-full sm:px-3 sm:pt-20
            ">
                <SectionText
                    className="max-w-[300px]"
                    title={t('landingPage.download.title')}
                    hrLineColor="bg-primary-blue"
                    discoverMore={false}>
                    <div className="justify-center">{t('landingPage.download.description')}</div>
                </SectionText>
            </div>
            <div
                className="w-1/2 flex items-center justify-center mx
                sm:w-full sm:px-3 sm:py-20
            ">
                <div
                    className="h-2/3 grid grid-cols-2 gap-x-10 gap-y-5
                    sm:grid-cols-1 sm:gap-x-0 sm:gap-y-5 sm:h-full
                ">
                    {[
                        {
                            title: t('landingPage.download.file1'),
                            icon: iconPdf,
                            link: 'downloads/Anamnesebogen Kinderorthopädie.pdf',
                        },
                        {
                            title: t('landingPage.download.file2'),
                            icon: iconPdf,
                            link: 'downloads/Anamnesefragebogen Enuresis kurze Kante-1.pdf',
                        },
                        {
                            title: t('landingPage.download.file3'),
                            icon: iconPdf,
                            link: 'downloads/kind-einnaessen-miktionsprotokoll.pdf',
                        },
                        {
                            title: t('landingPage.download.file4'),
                            icon: iconPdf,
                            link: 'downloads/Stuhlprotokoll.pdf',
                        },
                    ].map((item, index) => (
                        <a
                            key={index}
                            href={process.env.PUBLIC_URL + item.link}
                            download
                            target="_blank"
                            rel="noreferrer"
                            className="flex flex-col items-center justify-center w-full h-auto bg-secondary-green">
                            <div
                                className={`flex flex-col items-center justify-center object-center w-full h-full alt="${item.title}"`}>
                                <img src={`${item.icon}`} className="mx-auto" alt={`"${item.title}"`}></img>
                                <p className="text-center mx-2">{item.title}</p>
                            </div>
                        </a>
                    ))}
                </div>
            </div>
        </div>
    )
}
